import {ChangeDetectorRef, Component, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {NotificationService} from "../../../services/security/notification.service";
import {Notification} from "../../../model/security/notification";
import {UserInfoStorageService} from "../../../services/auth/user-info-storage.service";
import {ReportTaskService} from "../../../services/archive/report-task.service";
import {FileUtils} from "../../../utils/file-utils";
import {RecordRequest} from "../../../model/api/record-request";
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {DateTime} from "luxon";
import {OverlayPanel} from "primeng/overlaypanel";
import {AppConfigService} from "../../../services/app-config.service";
import {takeUntil, timer} from "rxjs";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationComponent extends CcBaseComponent {

  TYPE = Notification.TYPE;
  STATE = Notification.STATE;

  loading = false;
  enabled = false;
  currentDate: Date = new Date();

  @ViewChild('panel')
  panel;

  notifications: Notification[] = [];

  constructor(private notificationService: NotificationService,
              private reportTaskService: ReportTaskService,
              private appConfigService: AppConfigService,
              private userInfoStorageService: UserInfoStorageService,
              cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
    this.enabled = this.appConfigService.notificationEnabled;
  }

  ngOnInit(): void {
    this.needSyncNotificationList();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private setNotificationList(): void {
    this.notificationService.getNotifications(this.userInfoStorageService.getUsernameFromStorage()).subscribe(
      validationApi => {
        if (validationApi.success) {
          let notificationList: Notification[] = []
          validationApi.item.forEach(notification => {
            notification.icon = this.notificationService.getIconForNotification(notification);
            notificationList.push(notification);
          })

          this.notifications = notificationList
          this.markForCheck();
        }
      })
  }

  private needSyncNotificationList(recordRequest: RecordRequest = {}): void {
    if (this.destroyed || !this.enabled) return;
    this.currentDate = new Date();
    this.markForCheck();
    this.notificationService.getNotificationsSync(recordRequest, this.userInfoStorageService.getUsernameFromStorage()).subscribe(
      validationApi => {
        if (validationApi.success) {
          if (validationApi.item.needSync) {
            this.setNotificationList();
          }
        }

        timer( this.appConfigService.notificationsReloadInterval)
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => this.needSyncNotificationList({syncMetadata: validationApi.item}));
      })
  }

  removeNotif(currentNotif: Notification, index, op: OverlayPanel): void {
    this.loading = true;
    this.notifications.splice(index, 1);
    this.markForCheck();
    this.notificationService.deleteRecord([currentNotif.id + ''])
      .subscribe(response => {
        this.loading = false;
        if (response.success) {
        }
      });
    if (this.notifications.length == 0)
      op.hide();
  }

  removeAllNotif(op: OverlayPanel): void {
    this.loading = true;
    this.notifications.splice(0);
    this.markForCheck();
    this.notificationService.deleteAllNotification()
      .subscribe(response => {
        this.loading = false;
        if (response.success) {
        }
      })
    if (this.notifications.length == 0)
      op.hide();
  }

  relaunchDownload(notification: Notification): void {
    this.loading = true;
    this.markForCheck();
    if (notification.taskId) {
      this.reportTaskService.download(notification.taskId).subscribe(response => {
        if (response.success) {
          FileUtils.download(response);
          this.loading = false;
        }
      })
    }
  }
}
